import React, { useState } from 'react';
import "./configurations.css";
import axios from "axios";
import { useNavigate, useParams } from 'react-router-dom';
import Navbar from '../Navbar';
import { toast } from 'react-toastify';
import Menu_Items from '../Menu_Items';
import { BsDatabaseFillAdd } from "react-icons/bs";


function Configurations() {
    const navigate = useNavigate();
    const { id } = useParams();
    const [inval, setinval] = useState({ com_id: id });
    const menus = [
        {
            name: 'Integrations',
            id
        },
        {
            name: 'Users',
            id
        }
    ];
    const inputdata = (e) => {
        setinval({ ...inval, [e.target.id]: e.target.value });
    }
    const check = async () => {
        await axios.post("/integ/check", inval).then((res) => {
            toast.success(res.data, {
                autoClose: 2000, // 2 seconds
            });
        })
            .catch((err) => {
                toast.error(err.response.data, {
                    autoClose: 2000, // 2 seconds
                });
            })
    }
    const submit = async () => {
        await axios.post("/integ/add", inval).then((res) => {
            navigate(`/integ/${id}`);
        })
            .catch((err) => {
                toast.error("Configuration Submit Error", {
                    autoClose: 2000, // 2 seconds
                });

            })

    };
    return (
        <div className='container df fdc jb ac'>
            <Navbar />
            <div className='main_box df'>
                <Menu_Items menu={menus} />
                <div className='content df fdc ac'>
                    <div className='page_header df jb ac'>
                        <div className='w90 df ac'>
                            <BsDatabaseFillAdd className='page_icon db ' />
                            <p>Crete Integration</p>
                        </div>
                    </div>
                    <div className='box'>
                        <div className='create_box'>
                            <div>
                                <label htmlFor='integration_name'>Integration Name</label>
                                <input type='search' id='name' onChange={(e) => { inputdata(e) }} placeholder='Enter Integration Name' />
                            </div>
                            <div>
                                <label htmlFor='dbtype'>Database type</label>
                                <select id='dbtype' onChange={(e) => { inputdata(e) }}>
                                    <option value={""}>Select Database</option>
                                    <option value={"mysql"}>Mysql</option>
                                    <option value={"postgres"}>Postgres</option>
                                    <option value={"oracle"}>Oracle</option>
                                    <option value={"others"}>Others</option>
                                </select>
                            </div>
                            <div>
                                <label htmlFor='integration_database'>Database Name</label>
                                <input type='search' id='db' onChange={(e) => { inputdata(e) }} placeholder='Enter Database Name' />
                            </div>
                            <div>
                                <label htmlFor='integration_host'>Host Name</label>
                                <input type='search' id='hname' onChange={(e) => { inputdata(e) }} placeholder='Enter Host Name' />
                            </div>
                            <div>
                                <label htmlFor='integration_user'>User Name</label>
                                <input type='search' id='user' onChange={(e) => { inputdata(e) }} placeholder='Enter User Name' />
                            </div>
                            <div>
                                <label htmlFor='integration_password'>User Password</label>
                                <input type='search' id='password' onChange={(e) => { inputdata(e) }} placeholder='Enter User Password' />
                            </div>
                            <div>
                                <label htmlFor='c_type'>Access Type</label>
                                <select id='c_type' onChange={(e) => { inputdata(e) }} >
                                    <option value={""}>Select Type</option>
                                    <option value={"In Bound"}>In Bound</option>
                                    <option value={"Out Bound"}>Out Bound</option>
                                </select>
                            </div>
                        </div>
                        <div className='w100 h10 df jc ac gap1 white'>
                            <button className='btn h_blue' onClick={check}>Check</button>
                            <button className='btn green' onClick={submit}>Submit</button>
                        </div>
                    </div>
                </div>
            </div>
        </div >
    )
}

export default Configurations;